import type {MouseEventHandler, ReactNode} from 'react';
import {SquareX} from 'lucide-react';
import {cn} from '../lib/cn';

type TableFilterProps = {
  onRemove?: MouseEventHandler<SVGSVGElement>;
  children: ReactNode;
  onClick?: () => void;
  className?: string;
};

function TableFilter({onRemove, onClick, children, className}: TableFilterProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        `relative box-border h-[30px] w-[82px] overflow-hidden text-ellipsis whitespace-nowrap
        rounded-[3px] bg-[var(--table-filter-bg)] py-0 pl-2.5 pr-5 text-[15px] font-medium leading-[30px]
        text-[var(--table-filter-text)]`,
        className,
      )}
    >
      {children}
      <SquareX
        onClick={onRemove}
        size={15}
        fill="var(--table-filter-remove-bg)"
        color="var(--table-filter-remove-color)"
        strokeWidth={1.8}
        className="absolute bottom-0 right-1 top-0 my-auto h-[15px] w-[15px] cursor-pointer rounded-[3px]
          hover:shadow-[var(--table-filter-remove-hover-shadow)] hover:transition-shadow hover:duration-150
          hover:ease-in-out active:opacity-95"
      />
    </div>
  );
}

export {TableFilter};
export type {TableFilterProps};
